var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3882 0.746429C10.9671 0.445648 10.3828 0.540179 10.082 0.961273L5.46283 7.41518C5.33822 7.56127 5.17923 7.59135 5.0933 7.59994C5.00736 7.60424 4.83549 7.59565 4.69369 7.45815L1.70306 4.58354C1.32923 4.2269 0.736266 4.23549 0.379625 4.60932C0.0229848 4.98315 0.0315788 5.57612 0.405407 5.93276L3.39603 8.80737C3.84291 9.23276 4.44447 9.46908 5.05892 9.46908C5.11049 9.46908 5.16634 9.46908 5.21791 9.46479C5.88822 9.42182 6.51556 9.09526 6.93666 8.57104C6.94955 8.55815 6.95814 8.54526 6.96673 8.52807L11.6031 2.05268C11.9038 1.63588 11.805 1.04721 11.3882 0.746429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.3e1b97ae0ec75694283121cac38f25c4.svg";
export { ForwardRef as ReactComponent };